export default {
  data() {
    return { mounted: false };
  },

  mounted() {
    this.$emit('mounted');
    this.mounted = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/mountedMixin.js